// Auth Constants
export const GET_TOKEN  = 'auth/token/';
export const REFRESH_TOKEN = 'auth/token/refresh/';
export const CREATE_USER = 'auth/register/';
export const LOGOUT = 'auth/logout/';
export const USER_PASSWORD_UPDATE = 'auth/password-change/';
export const USER_UNLOCK_SCREEN = 'auth/login/';
export const RESET_PASSWORD =`auth/password-reset/request/`;

// User Constants
export const GET_USER = 'users/';
export const GET_PROFILE = 'profiles/me/';
export const USER_UPDATE = `users/username/`;
export const PROFILE_UPDATE = `profiles/username/`;
export const GET_EDUCATION_LIST = 'education/my_list/';
export const GET_EDUCATION = 'education/my/';
export const ADD_USER_EDUCATION = 'education/';
export const EDIT_USER_EDUCATION = 'education/id/';
export const GET_EXPERIENCE_LIST = 'experience/my_list/';
export const ADD_USER_EXPERIENCE = 'experience/';
export const EDIT_USER_EXPERIENCE = 'experience/id/';
export const GET_EXPERIENCE = 'experience/my/';
export const GET_PREVIOUS_CLIENT_LIST = 'consultants/id/previous-clients/';
export const FETCH_CONSULTANT_DROPDOWN_LIST = 'consultants/dropdown-list/';

export const GET_ADDRESS='addresses/id/';
export const GET_ADDRESS_LIST='addresses/id/';
export const ADD_USER_ADDRESS='addresses/';
export const EDIT_USER_ADDRESS='addresses/addId/id/';
export const DELETE_USER_ADDRESS='/addresses/delId/delete/id/'

export const GET_PRACTICE_LIST='consultants/id/practices/'
export const EDIT_USER_PRACTICE = 'consultants/id/practices/pracId/'
export const ADD_USER_PRACTICE = 'consultants/id/practices/'
export const GET_PRACTICE = 'consultants/id/practices/'

export const GET_SCREENING_CONSULTANTS = `consultants/screening-consultants/`;
// export const USER_UPDATE = 'users/username/';

//Consultant Constants
export const CREATE_CONSULTANT = 'consultants/';
export const CREATE_CONSULTANT_ADDTIONAL_INFO_FORM = 'consultants/forms/';
export const FETCH_CONSULTANT_ADDTIONAL_INFO_FORM_VALUE = 'consultants/slug/additional-fields/';
export const GET_ALL_CONSULTANTS = 'consultants/my/';
export const EDIT_CONSULTANT = `consultants/slug/`;
export const EDIT_CONSULTANT_STATUS = `consultants/slug/update-status/`;
export const EDIT_CONSULTANT_COMMENTS = `consultants/slug/addcomments/`;
export const GET_CONSULTANT = `consultants/slug/`;
export const FETCH_MEMBERS = `consultants/slug/members/`;
export const FETCH_ATTACHMENTS = `consultants/slug/attachments/`;
export const FETCH_COMMENTS = `consultants/slug/comments/`;
export const SEARCH_CONSULTANT = `consultants/search/`;
export const SEARCH_EXISITING_CONSULTANT = `consultants/search-by-contact/`;
export const CREATE_TRANSFER_REQUEST = `consultants/transfer-requests/by-me/`;
export const GET_TRANSFER_REQUEST_FOR_ME = `consultants/transfer-requests/for-me/`;
export const GET_TRANSFER_REQUEST_BY_ME = `consultants/transfer-requests/by-me/`;
export const UPDATE_TRANSFER_REQUEST = `consultants/transfer-requests/update-status/`;
export const ASSIGN_LEAD = `consultants/assign-lead/`;
export const MARKETING_PROFILE = `marketing/profiles/`;
export const CONTINUE_MARKETING = `consultants/slug/update-marketing-status/`;
export const TEAM_MARKETING_PROFILE = `marketing/profiles/?team_profiles=true`
export const UPDATE_MARKETING_PROFILE = `marketing/profiles/profId/update/`;
export const GET_SEARCHED_CONSULTANT = "consultants/conId/search-details/";
export const GET_CONTRACT_CONSULTANT_LIST = "contract/offer-consultants/";
export const SEND_CONSULTANT_CREDENTIAL = "consultants/slug/send-consultant-credentials/";

// consultant onboarding and bgc forms
export const GET_MARKETING_CONSULTANTS = `consultants/marketing-consultants/`;
export const MARKETING_PROFILE_TRANSFER = `marketing/profiles/profId/transfer/`;

// consultant onboarding and bgc forms
export const CONSULTANT_ONBOARDING = `consultants/on-boarding/`;
export const CONSULTANT_BACKGROUND = `consultants/bgc-details/`;

// actions - bgc and onboarding
export const ASK_CONSULTANT_ONBOARDING = `consultants/con_slug/ask_onboarding_details/`;
export const ASK_CONSULTANT_BGC = `consultants/conSlug/ask_bgc_details/`;

//Recruiter Constants
export const GET_CONSULTANTS = `consultants/my/`;
export const GET_TEAM_CONSULTANTS = `consultants/my/?team_profiles=true`;
export const GET_ON_OFFER_CONSULTANTS = `consultants/my/?on_offer=true&include_self=true`;
export const GET_RECRUITER_DASHBOARD_DATA = `employees/id/dashboard_data/`;
export const GET_SCREENING_RATIO = `employees/id/screenings_ratio/`;
export const GET_STATUS_RATIO = `consultants/status_ratio/`;
export const GET_ACTIVE_RATIO = `consultants/active_ratio/`;
export const GET_HIRED_RATIO = `consultants/hired_ratio/`;
export const GET_LEFT_RATIO = `consultants/left_ratio/`;
export const GET_RECENT_RECRUITS = `consultants/recent/`;
export const GET_RECENT_RECRUITS_BY_STATUS = `consultants/recruit_status/`;
export const GET_SCREENERS = `employees/id/screeners/`;
export const GET_SCHEDULED_SCREENINGS = `screenings/my/`;
export const UPDATE_SCREENING_STATUS = `screenings/id/`;
export const GET_EVENTS = `screenings/screener_calendar/`;
export const CREATE_EVENT = `screenings/create_event/`;
export const DELETE_EVENT = `screenings/delete_event/`;
export const GET_EMPLOYEE_CONSULTANTS = `consultants/recruiters/`;
export const BULK_REASSIGNMENT = `consultants/bulk_reassignment/`;
export const GET_RECRUITERS_ADDED_CONSULTANT_COUNT_LIST = `consultants/recruitment-data/`;
export const GET_EMPLOYEE_EMAILS_LIST = `employees/emails/`;
export const GET_RECRUITER_OFFERS = `consultants/recruiter-offers/`;

// ASSIGNA AND REMOVE MARKETER
export const ASSIGN_MARKETER = `consultants/slug/assign_marketer/`;
export const REMOVE_MARKETER = `consultants/remove-marketers/`;
export const REMOVE_CONSULTANT_FROM_MARKETER = `consultants/remove-consultants-from-marketers/`;

// Account details project-coordinator
export const ADD_ACCOUNT_DETAILS = `project-coordinators/support-persons/account-details/`;
export const GET_ACCOUNT_DETAILS_LIST = `project-coordinators/support-persons/account-details/`;
export const EDIT_PROJECT_COORDINATOR_ACCOUNT_DETAILS = `project-coordinators/support-persons/supprtPersonId/account-details/id/`;

// Account details Consultant
export const GET_CONSULTANT_ACCOUNT_DETAILS_LIST = `consultants/account-details/`;
export const GET_CONSULTANT_ACCOUNT_DETAILS_OBJECT = `finance/account-details/`;
export const ADD_COUNSULTANT_ACCOUNT_DETAILS = `consultants/account-details/`;
export const EDIT_CONSULTANT_ACCOUNT_DETAILS = `consultants/account-details/id/`;
export const GET_ACCOUNTS_SUPPORT_ACCOUNT_DETAILS_LIST = `finance/account-details/`;
export const GET_CONSULTANT_ACCOUNT_DETAILS_FROM_OFFERS = `finance/account-details/`;
export const GET_ACCOUNTS_CONSULTANT_ACCOUNT_DETAILS_LIST = `finance/account-details/`;
export const GET_CONSULTANT_BASIC_DETAILS_BY_ID = `consultants/consultantId/basic-details/`;





//Attachment Constants
export const ADD_ATTACHMENT = `attachments/`;
export const DELETE_ATTACHMENT = `attachments/id/`;
export const ATTACHMENT_STATUS = `attachments/id/update-status/`;

// Comment Constants
export const EDIT_COMMENT = `comments/id/`;

//Contact Constants
export const ADD_CONTACT = `contacts/`;
export const EDIT_CONTACT = `contacts/clientId/`;
export const GET_CONTACTS = `contacts/`;
export const GET_CLIENTS = `clients/`;
export const ADD_CLIENTS = `clients/`;
export const EDIT_CLIENTS = `clients/clientId/`;
export const ADD_POC = `contacts/`;
export const UPDATE_POC = `contacts/pocId/`;
export const REMOVE_DUPLICATE = `clients/remove-duplicate/`;

//Submission Constants
export const ADD_SUBMISSION = `submissions/`;
export const GET_SUBMISSION = `submissions/id/`;
export const EDIT_SUBMISSION = `submissions/id/`;
export const GET_MY_SUBMISSIONS = `submissions/my/`;
export const GET_PENDING_SUBMISSIONS = `submissions/pending/`;
export const GET_TEAM_SUBMISSIONS = `submissions/my/?team_profiles=true`;
export const FETCH_SUBMISSION_ATTACHMENTS = `submissions/id/attachments/`;
export const GET_ALL_SUBMISSIONS = `submissions/my/all-submissions/`;
export const DELETE_SUBMISSION = `submissions/submissionId/`;
// assessments constants
export const GET_ASSESSMENTS_LIST = `assessments/`;
export const GET_TEAM_ASSESSMENTS = `assessments/?team_profiles=true`
export const GET_ASSESSMENTS = `submissions/submissionId/assessments/`;
export const CREATE_ASSESSMENT_EVENT = `assessments/`;
export const EDIT_ASSESSMENTS = `assessments/assessmentId/`;
export const DELETE_ASSESSMENTS = `assessments/assessmentId/`;
export const EMPLOYEE_PERFORMENCE_ASSESSMENT = `assessments/employee-performence/`;


// offer constants
export const GET_OFFERS = `offers/`;
export const GET_MONTHWICE_OFFERS = `offers/current-month-offers/`;
export const GET_TEAM_OFFERS = `offers/?team_profiles=true`;
export const CREATE_OFFER = `offers/`;
export const DELETE_OFFER = `offers/offerId/delete/`;
export const EDIT_OFFERS = `offers/offerId/`

// project Coordinator
export const GET_PROJECT_COORDINATORS_LIST = `departments/employees/?department=project_coordination`;
export const GET_PROJECT_COORDINATORS_OFFERS = `project-coordinators/offers/`;
export const EDIT_PROJECT_COORDINATORS_OFFERS = `project-coordinators/offers/id/`;
export const EDIT_PROJECT_COORDINATORS_OFFERS_SUPPORT = `project-coordinators/offers/id/update-support/`;
export const GET_SUPPORT_PERSON_LIST = `offers/support-persons/`;
export const GET_SUPPORT_INVOICE_LIST = `project-coordinators/support-invoices/`;
export const GET_SUPPORT_INVOICE_DETAILS_LIST = `project-coordinators/support-invoices/invoice_number/details/`;
export const EDIT_SUPPORT_INVOICE = `project-coordinators/support-invoices/invoiceId/`;
export const UPDATE_INVOICE_ISPAID_STATUS = `project-coordinators/support-invoices/invoiceId/is-paid-update/`;
export const DELETE_SUPPORT_INVOICE = `project-coordinators/support-invoices/invoiceId/status-update/`;
export const GET_SUPPORT_PERSON_OPTION_LIST = `offers/support-persons/select-options/`;
export const ADD_SUPPORT_PERSON = `offers/support-persons/`;
export const EDIT_SUPPORT_PERSON = `offers/support-persons/id/`;
export const UPLOAD_INVOICE_ATTACHMENT = `project-coordinators/support-invoices/invoiceId/upload-attachments/`;
export const SEND_APPROVE_INVOICE_ATTACHMENT = `project-coordinators/support-invoices/invoiceId/resend-approval-mail/`;
export const SEND_APPROVE_SUPPORT_INVOICE_ATTACHMENT = `project-coordinators/support-invoices/invoiceId/send-approval-mail/`;
export const GET_SUPPORT_INVOICE_ATTACHMENT_TO_APPROVE = `project-coordinators/support-invoices/support-approved-invoices/`;
export const GET_SUPPORT_DETAILS_DATA = `project-coordinators/offers/offer-support-details/`;
export const GET_SUPPORT_INVOICE_TRANSACTION = `project-coordinators/transactions/invoice_number/details/`;
export const EDIT_SUPPORT_INVOICE_TRANSACTION = `project-coordinators/transactions/transactions_id/update-transactions/`;
export const GET_PROJECT_COORDINATORS_OFFERS_ASSIGNED_PAYEE_LIST = `project-coordinators/offers/offerId/payees/`;
export const ASSIGN_PAYEE_ON_OFFERS = `project-coordinators/offers/offerId/update-payees/`;
// export const ASSIGN_CONSULTANT_PAYEE_ON_OFFERS = `consultants/offers/offerId/update-payees/`;
export const ASSIGN_CONSULTANT_PAYEE_ON_OFFERS = `finance/offers/offerId/update-payees/`;
export const Edit_CONSULTANT_PAYEE_ON_OFFERS = `project-coordinators/offers/offerId/edit-payees/payeeId/`;

//engineer 
export const GET_ENGINEER_OFFERS = `offers/inhouse/`;
export const Edit_ENGINEER_OFFERS = `offers/inhouse/id/`;
export const GET_TIMESHEET_CONFIG_LIST = `timesheets/timesheet-config/?offer=`;
export const CREATE_TIMESHEET_CONFIG = `timesheets/timesheet-config/`;
export const ADD_TIMESHEET_HOURS = `timesheets/timesheet/`;
export const ADD_TIMESHEET_ATTACHMENT = `timesheets/timesheet-attachments/`;
export const EDIT_TIMESHEET_ATTACHMENT = `timesheets/timesheet-attachments/attachment_Id/update/`;
export const EDIT_TIMESHEET_HOURS = `timesheets/timesheet/`;
export const GET_TIMESHEET_HOURS_LIST = `timesheets/timesheet/`;
export const GET_TIMESHEET_ATTACHMENT_LIST = `timesheets/timesheet-attachments/`;
export const GET_CURRENT_YEAR_CLOSED_OFFER = `finance/current-year-closed-offers/`;
export const UPDATE_TIMESHEET_ATTACHMENT_STATUS = `timesheets/timesheet-attachments/attachmentId/update-status/`;
export const SEND_TIMESHEET_ATTACHMENT_REMINDER = `timesheets/missing-timesheets/offerId/send-reminder-mail/`;
export const DELETE_TIMESHEET_ATTACHMENT = `timesheets/timesheet-attachments/attachmentId/delete/`;

//contract team
export const GET_CONTRACT_TEAM_OFFERS = `contract/offers/`;
export const Edit_CONTRACT_TEAM_OFFERS = `contract/offers/offerId/`;
export const GET_CONTRACT_TEAM_DOCUMENT_LIST = `offers/offerId/contract-team/list-documents/`;
export const CONTRACT_TEAM_ATTACHMENT = `offers/offerId/contract-team/upload-documents/`;
export const APPROVE_CONTRACT_TEAM_ATTACHMENT = `offers/offerId/contract-team/documents/documentId/update-status/`;
export const GET_OFFERS_FINANCIAL_REPORT_LIST = `offers/offers-financial-report/download/`;

//consultant
export const GET_CONSULTANT_OFFERS = `consultants/offers/`;
export const GET_CONSULTANT_OFFERS_ASSIGNED_PAYEE_LIST = `consultants/offers/offerId/payees/`;

//Employee Constants
export const ALL_EMPLOYEES = `departments/employees/`;
export const CREATE_BULK_EMPLOYEE = `employees/bulk-create/`;
export const CREATE_EMPLOYEE = `employees/`;
export const GET_EMPLOYEE = `employees/id/`;
export const EDIT_EMPLOYEE = `employees/id/`;
export const GET_MANAGERS = `employees/managers/`;
export const GET_MARKETERS = `employees/marketers/`;
export const GET_ALL_RECRUITER = `employees/recruiters/`;
export const GET_EMPLOYERS = `employees/employers/`;
export const GET_DEPARTMENTS = `departments/`;
export const GET_LEVELS = `employees/levels/`;
export const FETCH_TASKS = `tasks/`;
export const GET_MARKETING_LEAD = `employees/leads/?department=marketer`;
export const GET_RECRUITMENT_LEAD = `employees/leads/?department=recruitment`;
export const EMPLOYEE_LIST = `employees/employees_list/`;
export const GET_MARKETERS_SUBORDINATES = `employees/marketer_subordinates/`;
export const GET_SUPPORT_ID_LIST = `departments/employees/?department=engineering`;
export const SEND_CREDENTIALS_TO_EMPLOYEE = `employees/id/reset-password/`;

// standup constants
export const GET_MARKETING_STANDUP_LIST = `analytics/marketing-standup/`;

// analytics constants
export const GET_OFFER_RATIO = `analytics/monthwise-total-offers/`;
export const GET_CURRENT_YEAR_ANALYTICS = `analytics/current-year-analytics/`;
export const GET_MARKETERS_ANALYTICS = `analytics/marketer-analytics/`;
export const GET_MARKETING_STATUS_COUNT = `analytics/status-marketing/`;
export const GET_ASSIGNED_CONSULTANT_DATA = `analytics/assigned-consultant-data/`;
export const GET_MARKETER_PNL_OFFERS = `analytics/marketing-profile-p&l/`;
export const GET_ONGOING_MARKETING_OFFERS =`analytics/total-ongoing-offers/`;
export const GET_CONSULTANT_COUNT_OF_RECRUITER = `analytics/recruiter-consultants/`;
export const GET_PROJECT_TYPE_TABLE_DATA = `analytics/profit-loss-by-project-type/`;
export const GET_TOTAL_MARKETING_PROFILE_TABLE_DATA = `analytics/marketing-profiles-by-technologies/`;
export const GET_ASSIGNED_CONSULTANT_BY_GROUP_TABLE_DATA = `analytics/assigned-consultants-and-profiles/`;
export const GET_MONTHWISE_SUBMISSION_AND_ASSESSMENT_DATA = `analytics/monthwise-submissions-and-assessments/`;
export const GET_CURRENT_WEEK_OFFERS_LIST = `analytics/current-week-offers/`;

//Static Data Constants

export const VISA_STATUS = 'visa/';
export const SOURCE_OPTIONS = 'source/';

// Notifications 
export const GET_NOTIFICATIONS = 'notifications/received/?page=pageNumber';
export const READ_NOTIFICATIONS = 'notifications/mark-read/';

// Transfer Requests Status Change

export const TRANSFER_REQUEST = 'consultants/transfer-requests/update-status/';

// Approve/Reject Practices

export const PRACTICES_STATUS = 'consultants/consId/practices/pracId/update-status/';

// Accounts 

export const GET_ACCOUNT_RECEIVABLE_LIST = 'finance/account-receivables/'
export const GET_ALL_OFFERS_EXCLUDING_JOINGING_PENDING = 'finance/offers/'
export const GET_ACCOUNT_OFFER_BY_YEAR_LIST = 'finance/current-year-offers/'
export const GET_MISSING_TIMESHEET_LIST = 'finance/offers/missing-timesheet-attachments/'
export const GET_MISSING_TIMESHEET_DETAILS = 'finance/offers/missing-timesheet-attachments/offerId/detail/'
export const GET_SIGNLE_ACCOUNT_RECEIVABLE_DATA = 'finance/account-receivables/receivablesId/'
export const EDIT_ACCOUNT_RECEIVABLE_DATA = 'finance/account-receivables/receivablesId/update/'
export const GET_ACCOUNT_CONSULTANT_LIST = "finance/accounts/offer-consultants/";
export const GET_ACCOUNT_CONSULTANT = "finance/offer-consultants/";
export const GET_CONSULTANT_ON_OFFERS_LIST = "finance/consultants-on-offers/";
export const GET_ACCOUNT_CONSULTANT_OFFERS = `finance/offers/`;
export const GET_ACCOUNT_PAYROLL_DETAILS = `finance/offers/payroll-details/`;
export const GET_ACCOUNT_SUPPORT_OFFERS = `finance/support/support_id/offers/`;
export const GET_ACCOUNT_SUPPORT_OFFERS_ASSIGNED_PAYEE_LIST = `payees/?object_type=support`;
export const GET_All_ACCOUNT_PAYEE_LIST = `payees/`;
export const GET_ACCOUNT_CONSULTANT_OFFERS_ASSIGNED_PAYEE_LIST = `payees/?object_type=consultant`;
export const GENERATE_PAYROLL = 'finance/generate-payroll/'
export const CREATE_PAYROLL_CACHE = 'finance/payroll-cache/'
// export const GET_PAYROLL_CACHE = 'finance/payroll-cache/consultant/consultant_id/'
export const GET_PAYROLL_CACHE = 'finance/payroll-cache/retrieve-consultants/'
export const GET_APPROVED_HOURS = `finance/offers/offerId/total-approved-hours/`;
export const EDIT_ACCOUNTS_OFFERS = `finance/offers/offerId/edit-offers/`;
export const SEND_CONSULTANT_INVOICE_APPROVE_MAIL = `finance/payroll-cache/cache_id/payee/payee_id/offer/offer_id/payee-type/payeeType/`;
export const GET_TRANSACTION_LIST = `finance/transactions/`;
export const UPDATE_TRANSACTION_LIST = `finance/transactions/transactionId/update/`;
export const DELETE_TRANSACTION_LIST = `finance/transactions/transactionId/delete/`;
export const GET_INVOICE_NUMBER_LIST = `finance/transactions/invoice-numbers/`;
export const GET_TRANSATION_LIST_FROM_INVOICE_NUMBER = `finance/transactions/invoice_number/details/`;
export const GET_TRANSATION_LIST_TO_DOWNLOAD = `finance/transactions/`;
export const ADD_REIMBURSEMENT = `finance/reimbursement-requests/`;
export const Edit_REIMBURSEMENT = `finance/reimbursement-requests/reimbursementId/update/`;
export const Edit_REIMBURSEMENT_STATUS = `finance/reimbursement-requests/reimbursementId/update-status/`;

// last interview and last offer
export const GET_LAST_INTERVIEW_AND_LAST_OFFER = `analytics/marketer-assessments-and-submissions-activity/`;

// create education for marketing profile
export const CREATE_EDUCATION_FOR_MARKETIMNG_PROFILE = `marketing/profiles/educations/`
export const DELETE_EDUCATION_FOR_MARKETING_PROFILE = `marketing/profiles/educations/id/delete/`
export const GET_EDUCATION_FOR_MARKETING_PROFILE = `marketing/profiles/educations/id/profile-educations/`
export const UPDATE_EDUCATION_FOR_MARKETING_PROFILE = `marketing/profiles/educations/id/update/`
export const GET_EDUCATION_FOR_MARKETING_PROFILE_BY_ID = `marketing/profiles/educations/id/`




